import { render, staticRenderFns } from "./minorAdd.vue?vue&type=template&id=37a32319&scoped=true"
import script from "./minorAdd.vue?vue&type=script&lang=js"
export * from "./minorAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a32319",
  null
  
)

export default component.exports